import { IFaqState, IFaqtateFulfilled, IStateRejected } from '../../interfaces';
import { faqAction } from '../actions';

const findAllFaq = () => {
  const { pending, fulfilled, rejected } = faqAction.findAllFqa;
  return {
    // Pending
    [pending.type]: (state: IFaqState): IFaqState => ({
      ...state,
      status: 'loading',
      error: '',
    }),
    // Fulfilled
    [fulfilled.type]: (_: IFaqState, action: IFaqtateFulfilled): IFaqState => ({
      status: 'success',
      faqs: action.payload,
      error: '',
    }),
    // Rejected
    [rejected.type]: (_: IFaqState, action: IStateRejected): IFaqState => ({
      faqs: [],
      status: 'error',
      error: action.error.message,
    }),
  };
};

export default {
  ...findAllFaq(),
};
